var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":"","border-variant":"secondary","header":_vm.$t('title.notes'),"header-bg-variant":"secondary","header-text-variant":"white","align":"left"}},[_c('b-card-body',[_c('notes-tab')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }